var exports = {
  "x": "xe533113f--a08a03--thumbnail",
};

module.exports = exports;
